<template>
  <div class="tags-page">
    <app-view-layout
      header="Tagi"
    >
      <template #toolbarMenu>
        <v-btn
          color="primary"
          @click="openTagDialog()"
        >
          Dodaj tag
        </v-btn>
      </template>
      <template #content>
        <v-card class="mt-4 pa-6 pb-2">
          <AppSearchInput
            search-placeholder="Wyszukaj tagu po nazwie"
            class="mb-6"
            @search="searchQuery = $event"
          />
          <v-fade-transition mode="out-in">
            <div v-if="filteredTags.length">
              <v-chip
                v-for="tag in filteredTags"
                :key="'tag' + tag.id"
                class="mr-4 mb-4"
              >
                {{ tag.name }}
                <v-btn
                  color="primary"
                  class="ml-2 mr-n1"
                  v-bind="btnProps"
                  @click="openTagDialog(tag)"
                >
                  <v-icon small>
                    mdi-pencil-circle
                  </v-icon>
                </v-btn>
                <v-btn
                  color="red accent-4"
                  class="mr-n2"
                  v-bind="btnProps"
                  @click="openConfirmationDialog(tag)"
                >
                  <v-icon small>
                    mdi-close-circle
                  </v-icon>
                </v-btn>
              </v-chip>
            </div>
            <AppEmptyList
              v-else
              key="emptyList"
              class="my-15"
              header="Nie znaleziono żadnych tagów."
              text="Dodaj tag lub zmień kryteria wyszukiwania."
            />
          </v-fade-transition>
        </v-card>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import AppSearchInput from '@/components/UI/AppSearchInput.vue';
import AppEmptyList from '@/components/UI/AppEmptyList.vue';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    AppViewLayout,
    AppSearchInput,
    AppEmptyList,
  },
  data: () => ({
    searchQuery: '',
    btnProps: {
      icon: true,
      small: true,
      plain: true,
    },
  }),
  computed: {
    ...mapState('tags', [
      'tags',
    ]),
    filteredTags() {
      return this.searchQuery
        ? this.tags.filter(
          (tag) => tag.name.toLowerCase().includes(this.searchQuery?.toLowerCase()),
        ) : this.tags;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchTags();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.fetchFiltersOptions();
    next();
  },
  methods: {
    ...mapActions('tags', [
      'fetchTags',
      'deleteTag',
    ]),
    ...mapActions('dialog', [
      'showDialog',
      'clearDialog',
    ]),
    ...mapActions('filters', [
      'fetchFiltersOptions',
    ]),
    openTagDialog(tag) {
      this.showDialog({
        header: tag ? 'Zapisz tag' : 'Stwórz tag',
        component: 'TagForm',
        props: {
          tag,
        },
      });
    },
    openConfirmationDialog(tag) {
      this.showDialog({
        header: 'Usuwanie taga',
        text: 'Czy na pewno chcesz usunąć ten tag?',
        component: 'Confirm',
        props: {
          confirmText: 'Usuń',
          rejectText: 'Nie usuwaj',
        },
      })
      .then(() => {
        this.deleteTag(tag.id);
      })
      .catch(() => {
        this.clearDialog();
      });
    },
  },
};
</script>
